export default "__VITE_ASSET__41be201f__"